import React from 'react';

import { adminPharmaciesInfo, PaymentPlans } from '@pharmaplan/common';

import OutcomeModal from '../../components/Modals/OutcomeModal';
import { OutcomeModalTypes } from '../../helpers/Constants';
import { setDialog } from '../../reducers/dialogReducer';
import { useAppDispatch } from '../useAppDispatch';
import { useAppSelector } from '../useAppSelector';
import useSelfService from '../useSelfService';
import strings from '../../localization';

const { basic } = PaymentPlans;

const useAdminBookingBlock = () => {
  const dispatch = useAppDispatch();
  const info = useAppSelector(adminPharmaciesInfo);
  const { isSelfService } = useSelfService();
  const { planName } = info ?? {};

  const disableActionBookings = (currPlan?: string | null) => {
    const isBasicPlan = currPlan?.toLowerCase?.() === basic;
    const disableActions = isSelfService && (isBasicPlan || !currPlan);
    return disableActions;
  };

  const disableActionShifts = (currPlan?:string|null) =>
    !currPlan && isSelfService;

  const actionRequiredDialog = () => {
    let message = strings.cannotCreateShiftAdmin;

    if (planName?.toLowerCase?.() === basic) {
      message = strings.cannotBookShiftAdmin;
    }

    dispatch(
      setDialog({
        Component: (
          <OutcomeModal
            type={OutcomeModalTypes.adminCannotCreateShift}
            message={message}
          />
        ),
        showCloseButton: true,
        heading: {
          title: '',
        },
      }),
    );
  };

  return {
    actionRequiredDialog,
    disableActions: disableActionBookings(planName),
    disableActionBookings,
    disableActionShifts,
  };
};

export default useAdminBookingBlock;
